import { Badge, Group, Tooltip } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { toIsoCode, languageLabel, languageDisplayLabel } from "../constants/languages";

// Renders a candidate's languages as proper chips instead of a bare "en, fr" code string.
// Each chip shows the native short label (Deutsch, English, …); hovering reveals the full
// bilingual name ("German (Deutsch)") so the meaning of an unfamiliar code is one hover away.
// Deliberately NO country flags: a language is not a country (English ≠ 🇬🇧/🇺🇸, Arabic spans
// ~25 countries) — flags-for-languages is a well-known i18n anti-pattern, so we show the name.
export default function LanguageBadges({ languages, max = 6, size = "xs", ...groupProps }) {
  const { i18n } = useTranslation("Veft");
  const codes = [...new Set((languages ?? []).map(toIsoCode))].filter(Boolean);
  if (codes.length === 0) return null;

  const shown = codes.slice(0, max);
  const overflow = codes.length - shown.length;

  return (
    <Group gap={4} wrap="wrap" {...groupProps}>
      {shown.map((code) => (
        <Tooltip key={code} label={languageDisplayLabel(code, i18n.language)} withArrow openDelay={200}>
          <Badge size={size} variant="light" color="grape" tt="none" style={{ cursor: "default" }}>
            {languageLabel(code)}
          </Badge>
        </Tooltip>
      ))}
      {overflow > 0 && (
        <Tooltip
          label={codes.slice(max).map((c) => languageDisplayLabel(c, i18n.language)).join(", ")}
          withArrow
          openDelay={200}
        >
          <Badge size={size} variant="light" color="gray" tt="none" style={{ cursor: "default" }}>
            +{overflow}
          </Badge>
        </Tooltip>
      )}
    </Group>
  );
}
